module.exports = __webpack_public_path__ + "img/thumbnail.907bb940.png";